import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeader } from "./_shared";

export default function PricingAccess() {
  const tiers = [
    { name: "Startup Basic", audience: "startup", bullets: ["Create Startup Passport", "Upload basic documents", "Company verification", "Basic profile readiness"], cta: "Coming Soon", disabled: true },
    { name: "Startup Growth", audience: "startup", bullets: ["Basic Health Check", "Readiness recommendations", "Investor visibility", "Controlled query workflow"], cta: "Coming Soon", disabled: true },
    { name: "Startup Premium", audience: "startup", bullets: ["Detailed DD Report", "Priority review", "Deal room eligibility", "Enhanced investor access"], cta: "Contact Team", href: "/support", featured: true },
    { name: "Investor Access", audience: "investor", bullets: ["Verified opportunity discovery", "Mandate fit", "Interest workflow", "Health Check summary access"], cta: "Join as Investor", href: "/investor/join" },
    { name: "Investor Premium", audience: "investor", bullets: ["DD access requests", "Investor memo", "Deal room access", "Advanced filters"], cta: "Contact Team", href: "/support", featured: true },
  ];
  return (
    <section id="pricing" className="py-16 lg:py-20 bg-white" data-testid="pricing-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader
          eyebrow="ACCESS TIERS"
          title="Access built around seriousness and control."
          subtitle="VENTURAZ tiers are access-first, not seat-first. Some tiers are still being rolled out — talk to our team for enterprise or bespoke access."
          align="center"
        />
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-4">
          {tiers.map((t, i) => (
            <div
              key={t.name}
              className={`rounded-lg border p-5 flex flex-col ${t.featured ? "border-gold/60 bg-gold/[0.05] shadow-md" : "border-navy/10 bg-cream/50"}`}
              data-testid={`pricing-card-${i + 1}`}
            >
              <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-gold">
                {t.audience === "startup" ? "STARTUP" : "INVESTOR"}
              </div>
              <div className="font-heading text-lg text-ink mt-1">{t.name}</div>
              <ul className="mt-3 space-y-1.5 text-sm text-ink-soft flex-1">
                {t.bullets.map((b) => (
                  <li key={b} className="flex items-start gap-2">
                    <span className="mt-1.5 w-1 h-1 rounded-full bg-gold flex-shrink-0" />
                    {b}
                  </li>
                ))}
              </ul>
              {t.disabled ? (
                <div className="mt-4 text-center text-[11px] font-mono uppercase tracking-wider bg-navy/5 text-ink-muted rounded py-2" data-testid={`pricing-cta-${i + 1}`}>
                  {t.cta}
                </div>
              ) : (
                <Link
                  to={t.href}
                  className={`mt-4 inline-flex items-center justify-center gap-1 px-4 py-2 rounded-md font-heading text-sm transition-colors ${t.featured ? "bg-navy text-cream hover:bg-[#256E58]" : "bg-white border border-navy/15 text-ink hover:border-gold hover:text-[#8A6600]"}`}
                  data-testid={`pricing-cta-${i + 1}`}
                >
                  {t.cta} <ArrowRight size={12} />
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
